export default __webpack_public_path__ + "static/media/Typescript_logo_2020.e0cf5672.svg";